/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Simplified address for the creation of a borrower real estate property.
 * @export
 * @interface CreateBorrowerRealEstateAddressDto
 */
export interface CreateBorrowerRealEstateAddressDto {
    /**
     * 
     * @type {string}
     * @memberof CreateBorrowerRealEstateAddressDto
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBorrowerRealEstateAddressDto
     */
    line2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateBorrowerRealEstateAddressDto
     */
    line3?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateBorrowerRealEstateAddressDto
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBorrowerRealEstateAddressDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBorrowerRealEstateAddressDto
     */
    country: string;
}

/**
 * Check if a given object implements the CreateBorrowerRealEstateAddressDto interface.
 */
export function instanceOfCreateBorrowerRealEstateAddressDto(value: object): value is CreateBorrowerRealEstateAddressDto {
    if (!('line1' in value) || value['line1'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    return true;
}

export function CreateBorrowerRealEstateAddressDtoFromJSON(json: any): CreateBorrowerRealEstateAddressDto {
    return CreateBorrowerRealEstateAddressDtoFromJSONTyped(json, false);
}

export function CreateBorrowerRealEstateAddressDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBorrowerRealEstateAddressDto {
    if (json == null) {
        return json;
    }
    return {
        
        'line1': json['line1'],
        'line2': json['line2'] == null ? undefined : json['line2'],
        'line3': json['line3'] == null ? undefined : json['line3'],
        'zipCode': json['zipCode'],
        'city': json['city'],
        'country': json['country'],
    };
}

export function CreateBorrowerRealEstateAddressDtoToJSON(json: any): CreateBorrowerRealEstateAddressDto {
    return CreateBorrowerRealEstateAddressDtoToJSONTyped(json, false);
}

export function CreateBorrowerRealEstateAddressDtoToJSONTyped(value?: CreateBorrowerRealEstateAddressDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'line1': value['line1'],
        'line2': value['line2'],
        'line3': value['line3'],
        'zipCode': value['zipCode'],
        'city': value['city'],
        'country': value['country'],
    };
}

